import type { ReactNode } from 'react';

export const PageHeading = ({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}) => (
  <div className="md:flex md:items-center md:justify-between">
    <div className="min-w-0 flex-1">
      {eyebrow ? <p className="text-sm font-semibold text-accent-ink">{eyebrow}</p> : null}
      <h1 className="text-2xl/7 font-bold tracking-tight wrap-anywhere text-content sm:truncate">
        {title}
      </h1>
      {description ? <p className="mt-2 text-sm text-muted">{description}</p> : null}
    </div>
    {actions ? (
      <div className="mt-4 flex min-w-0 flex-wrap gap-x-3 gap-y-3 md:mt-0 md:ml-4">{actions}</div>
    ) : null}
  </div>
);
